// Read text file for irradiance
//import React from 'react';
const fetch = require('node-fetch');
const fs = require('fs');

//fs.readFile('/Users/balazskisfali/Downloads/global_radiation.txt', 'utf8', function(err,data) {
//  if (err) throw err;
//  console.log(data[0])
//});

const url = "https://storage.googleapis.com/shm02-exposure/max_no_sun.txt";

const GetMaxNoSun = (lat, lon) => {
  return fetch(url, {
    method: 'GET',
    data: JSON.stringify({})
  }).then(response => {
    if (response.ok) {
      return response.text();
    }
    throw new Error("Request to S3 has failed!");
  }, networkError => console.log(networkError.message)).then(
    textResponse => {
      return textResponse;
    }
  ).then(data => {
    let lines = data.split('\n')
    let row;
    for (let i = 0; i < lines.length; i++) {
      if (lines[i].indexOf(`${lat} ${lon} `) === 0) {
        row = lines[i];
      }
    }
    return {
      "description": lines[2],
      "nosun": row.split(' ').slice(2),
      "months": ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    };
  })
};


export default GetMaxNoSun;

//fetchIrradianceTilt()

/*
class Irradiance extends React.Component {
  render(){
    return (
      <p>Heelloooo from Irradiance.js</p>
    )
    //...do something
  }
}

export default Irradiance;   */



// WEBPACK FOOTER //
// ./src/utils/MaxNoSun.js